const styles = theme => ({
  addBtnContent: {
    border: '1px solid #130F26',
    '& >span': {
      gap: '10px',
    },
    textTransform: 'lowercase',
    '& ::first-letter': {
      textTransform: 'uppercase',
    },
    '&:hover': {
      '& img': {
        filter: 'invert(1)',
      },
      backgroundColor: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
      border: 'none',
    },
  },
  emptyHeading: {
    fontWeight: '600',
    fontSize: '18px',
    marginBottom: '16px',
  },
  titleHead: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gridTemplateRows: 'auto auto',
    alignItems: 'center',
    '& h1': {
      gridColumn: ' 1 / 2',
      gridRow: '1 / 2',
      margin: 0,
    },
    '& span': {
      gridColumn: ' 1 / 2',
      gridRow: '2 / 3',
      margin: 0,
    },
    '& button': {
      gridColumn: ' 2 / 3',
      gridRow: '1 / 3',
      alignSelf: 'center',
    },
  },
  title: {
    fontWeight: '600',
    marginBottom: '5px',
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  '@media (min-width: 768px)': {
    // titleHead: {
    //   padding: '16px 24px',
    //   '& h1': {
    //     fontSize: '20px',
    //   },
    // },
    title: {
      fontSize: '20px',
    },
  },
  '@media (max-width: 767px)': {
    // titleHead: {
    //   flexWrap: 'wrap',
    // },
  },
  modalContainer: {
    maxHeight: '75vh',
    // minHeight: '42vh',
    overflowX: 'hidden',
    overflowY: 'auto',
    borderTop: '1px solid #CED1D6',
    [theme.breakpoints.down('xs')]: {
      borderTop: 'none',
      minHeight: '60vh',
      '& .MuiGrid-item': {
        padding: '8px 16px',
      },
    },
    '& .MuiGrid-item': {
      padding: '8px',
      [theme.breakpoints.down('sm')]: {
        padding: '12px 24px',
      },
    },
  },
  modalModified: {
    [theme.breakpoints.down('xs')]: {
      minWidth: 'auto',
      width: 'auto',
    },
  },
  modalModifiedContent: {
    padding: '0px',
  },
  modalContainerModified: {
    '& textarea': {
      height: '152px !important',
    },
    [theme.breakpoints.down('xs')]: {
      '& input, & p': {
        fontSize: '16px',
      },
      padding: '0px',
    },
  },
  modalSectionTittle: {
    marginBottom: '8px',
    [theme.breakpoints.down('xs')]: {
      '& input, & p': {
        fontSize: '16px',
      },
      fontSize: '16px',
      marginBottom: '0px',
    },
  },
  modalTitleWrapper: {
    [theme.breakpoints.down('xs')]: {
      background: '#F8F8F8',
      padding: '16px 20px !important',
    },
  },
  buttonSection: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    padding: '0px 16px',
    marginBottom: '25px',
    '& button': {
      minWidth: '139px',
      width: '100%',
      padding: '10px 40px',
      fontWeight: '600',
      fontSize: '16px',
      borderRadius: '4px',
      textTransform: 'none',
      [theme.breakpoints.down('sm')]: {
        padding: '16px 24px',
        fontSize: '12px',
      },
      // '&:hover': {
      //   boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.3)',
      // },
    },
  },
  buttonSectionDelete: {
    display: 'flex',
    justifyContent: 'center',
    gap: '16px',
    '& button': {
      minWidth: '139px',
      fontWeight: '600',
      fontSize: '16px',
      borderRadius: '4px',
      textTransform: 'none',
      padding: '12px 0px',
      width: '100%',
      '&:hover': {
        boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.3)',
      },
    },
    '& $deleteSubmitButton': {
      color: '#fff',
      background: theme.palette.primary.main,
    },
    '& $deleteCancelButton': {
      background: '#FFFFFF',
      color: '#130F26',
      border: '1px solid #130F26',
    },
  },
  cancelButton: {
    backgroundColor: '#fff',
    border: '1px solid #342D3D',
    color: '#342D3D',
  },
  submitButton: {
    color: '#fff',
    background: theme.palette.primary.main,
  },
  [theme.breakpoints.down('sm')]: {
    // titleHead: {
    //   padding: '16px 20px',
    // },
  },
  infoPanel: {
    fontWeight: 500,
    color: theme.palette.primary.adgmBlack,
  },
  [theme.breakpoints.down('sm')]: {
    infoPanel: {
      width: 'calc(100% - 30px)',
      margin: '0 auto 16px',
    },
  },
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '16px',
  },
  upload: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '5px',

    '&:hover': {
      border: 'none',
      background: theme.palette.primary.adgmHover, // Corrected "background" spelling
      color: theme.palette.primary.white,
      '& svg path': {
        // Removed colon for correct CSS targeting
        fill: theme.palette.primary.white,
      },
    },
  },
});
export default styles;
